import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import RegisterPage from '../../../pages/register/container';

export const routes = (registerPath) => ({
  path: registerPath,
  pages: {
    register: {
      path: `${registerPath}`,
    },
  },
});

export const RegisterRoutes = ({ match: { url } }) => {
  const applicationRoutes = routes(url);
  return (
    <Switch>
      <Route path={applicationRoutes.pages.register.path} component={RegisterPage} />
      <Redirect to={applicationRoutes.pages.register.path} />
    </Switch>
  );
};

RegisterRoutes.propTypes = {};
